export const MAX_PART_LINES_PER_CREATE = 50;
export const MAX_PART_LINES_PER_CREATE_MESSAGE = `A maximum of ${MAX_PART_LINES_PER_CREATE} parts can be ordered at a time.`;
const EXPECTED_DELIVERY_LABEL = 'Expected delivery';
export const PURCHASE_ORDER_CONSTRAINTS = {
    vendor: { label: 'Vendor' },
    locationGroup: { label: 'Ship-to warehouse' },
    brand: { label: 'Brand' },
    paymentTerms: { label: 'Payment terms' },
    fobPoint: { label: 'FOB point' },
    note: { maxLength: 4000, label: 'Notes' },
    deliverTo: { maxLength: 30, label: 'Deliver to' },
    shipToName: { maxLength: 60, label: 'Ship-to name' },
    shipToAddress: { maxLength: 90, label: 'Ship-to address' },
    shipToCity: { maxLength: 30, label: 'Ship-to city' },
    shipToZip: { maxLength: 10, label: 'Ship-to ZIP' },
    dateFirstShip: { label: EXPECTED_DELIVERY_LABEL },
    // Same column as dateFirstShip, so the labels stay equal (see settled-decisions-purchasing.md).
    expectedDeliveryDate: { label: EXPECTED_DELIVERY_LABEL },
    dateConfirmed: { label: 'Confirmed date' },
    part: { label: 'Part' },
    quantity: { label: 'Quantity' },
    unitCost: { label: 'Unit cost' },
    taxRate: { label: 'Tax rate' },
    vendorOverride: { label: 'Vendor' },
    items: { label: 'Parts to order' },
};
//# sourceMappingURL=constraints.js.map